var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/**
 * @copyright
 * Copyright(c) 2020 SICK AG
 */

/* eslint-disable jsdoc/require-returns */
import { Component, html, Prop, Event, ifDefined, Watch } from '@sick-davinci/ce-decorators';
import { style } from './LegendGrid.style';
import { ColoredDataElement } from '../_utils/ColoredDataElement.js'; // should be imported first, so css variables from theme-base are available

import { LEGEND_BOX, SYMBOL_GENERATOR, MULTI_SYMBOL_GENERATOR } from './LegendSymbols.js';
import { toCssColorValue, resolveCssColor } from '../_utils/ColorTools.js';
import { SvgTools } from '../_utils/SvgTools.js';
import { ThemeService } from '../_utils/ThemeService.js';
import { icon_visibility } from '@sick-davinci/material-icons/action/visibility.icon.js';
import { icon_visibility_off } from '@sick-davinci/material-icons/action/visibility_off.icon.js';
import { CssTools } from '../_utils/CssTools.js';
/**
 * Compass orientation
 */

export
/**
 * A legend alignes legend-items around any dashboard-element.
 * To be used inside <dashboard-element>
 *
 * @example
 * ```
 * <div style="width: 400px; height: 300px">
 *   <davinci-element-container>
 *     <davinci-legend placement="SE" symbols='["disc"]' labels='["Hamburg", "Freiburg"]' >
 *       <davinci-numeric-chart value='42'></davinci-numeric-chart>
 *     </davinci-legend>
 *   </davinci-element-container>
 * </div>
 * ```
 * @slot { * } default - default slot, can consume any element
 */
let LegendGrid = (_dec = Component({
  tag: 'davinci-legend',
  style
}), _dec2 = Reflect.metadata("design:paramtypes", []), _dec3 = Prop(), _dec4 = Reflect.metadata("design:type", Object), _dec5 = Prop({
  type: String
}), _dec6 = Reflect.metadata("design:type", Object), _dec7 = Prop(), _dec8 = Reflect.metadata("design:type", Boolean), _dec9 = Prop(), _dec10 = Reflect.metadata("design:type", Boolean), _dec11 = Event(), _dec12 = Reflect.metadata("design:type", Object), _dec13 = Prop({
  reflectAsAttribute: false
}), _dec14 = Reflect.metadata("design:type", Object), _dec15 = Prop({
  type: Array()
}), _dec16 = Reflect.metadata("design:type", Object), _dec17 = Prop(), _dec18 = Reflect.metadata("design:type", Number), _dec19 = Prop(), _dec20 = Reflect.metadata("design:type", Number), _dec21 = Prop(), _dec22 = Reflect.metadata("design:type", Boolean), _dec23 = Prop(), _dec24 = Reflect.metadata("design:type", Number), _dec25 = Prop(), _dec26 = Reflect.metadata("design:type", Object), _dec27 = Watch('palette'), _dec28 = Reflect.metadata("design:paramtypes", []), _dec(_class = _dec2(_class = (_class2 = class LegendGrid extends ColoredDataElement {
  /**
   * list of all lables to show (limit is maxItem [12])
   */

  /**
   * the placement of the legend
   */

  /**
   * If set the legend-items are as close as possible
   */

  /**
   * If set the legend items can be toggled.
   * The emitted toggle state can be used by charts to enable/disable data series.
   * Register to @link legendStateChanged in order to get informed about state changes
   */

  /**
   * Fire legend status if a single legend item has been clicked on.
   * Set @link interactiveLegend to activate this event
   *
   */

  /**
   * a list of symbols, can be less than the number of labels, will wrapped automatically
   *
   * @default []
   */
  get symbols() {
    return [];
  }

  set symbols(symbols) {
    if (symbols.length === 1) {
      this._currentGenerator = SYMBOL_GENERATOR(symbols[0]);
    } else {
      this._currentGenerator = MULTI_SYMBOL_GENERATOR(symbols);
    }
  }
  /**
   * defines if the symbol is drawn left or right next to the label
   * can be less than the number of labels, will wrapped automatically
   */


  /**
   * The colors to be used for the symbols of the legend.
   * The first element denotes the color for the first segment, the second element denotes the color for the second segment so on.
   * Each entry of this array is either interpreted as an index referring to the selected palette, or a css-color-value designation (e.g. 'purple', '#ff00ff', 'rgba(255,255,128,0.5)')
   *
   * If there are more segments than colors the array will be traversed from the beginning
   *
   * @default all colors of the current color-palette
   */
  get colors() {
    return this._getSeriesColors();
  }

  set colors(value) {
    this._setSeriesColors(value);

    this._computeItemColors();
  }

  paletteWatcher() {
    this._computeItemColors();

    this.scheduleRender(true);
  }

  constructor() {
    super();
    this._currentGenerator = LEGEND_BOX;
    this._legendState = [];

    _initializerDefineProperty(this, "labels", _descriptor, this);

    _initializerDefineProperty(this, "placement", _descriptor2, this);

    _initializerDefineProperty(this, "compact", _descriptor3, this);

    _initializerDefineProperty(this, "interactiveLegend", _descriptor4, this);

    _initializerDefineProperty(this, "legendStateChanged", _descriptor5, this);

    _initializerDefineProperty(this, "symbolPositions", _descriptor6, this);

    _initializerDefineProperty(this, "symbolSize", _descriptor7, this);

    _initializerDefineProperty(this, "toggleSize", _descriptor8, this);

    _initializerDefineProperty(this, "smallFont", _descriptor9, this);

    _initializerDefineProperty(this, "maxItems", _descriptor10, this);

    this._computeItemColors();
  }
  /**
   * generator setter
   * don't use with "symbol" property together
   *
   * @param symbolGen - the symbolGenerator
   */


  setSymbolGenerator(symbolGen) {
    this._currentGenerator = symbolGen;
  }
  /**
   * See base class
   */


  render() {
    return html`
    ${this._generateN()}
      ${this._generateW()}
      <div id="MID">
        <slot></slot>
      </div>
      ${this._generateE()}
      ${this._generateS()}
    `;
  }

  componentConnected() {
    super.componentConnected();
    ThemeService.GET_INSTANCE().addListener(() => this.paletteWatcher());
  }

  _calcWidth(part) {
    const {
      partSize
    } = this._getPartRange(part);

    let out = 'gridx';

    if (partSize === 1) {
      out = 'grid1';
    } else if (partSize === 2 || partSize === 4) {
      out = 'grid2';
    } else if (partSize === 3 || partSize === 6) {
      out = 'grid3';
    }

    return out;
  }

  _generateN() {
    return this.placement === 'N' || this.placement === 'N&S' ? html`
    <davinci-legend-grid-block type="${this._calcWidth(0)}" compact=${ifDefined(this.compact)}>
      ${this._genItems(0)}
    </davinci-legend-grid-block>
    ` : html``;
  }

  _generateS() {
    const part = this.placement === 'S' ? 0 : 1;
    return this.placement === 'S' || this.placement === 'N&S' ? html`
    <davinci-legend-grid-block type="${this._calcWidth(part)}" compact=${ifDefined(this.compact)}>
      ${this._genItems(part)}
    </davinci-legend-grid-block>
    ` : html``;
  }

  _generateE() {
    return this.placement.match(/[NS]?E/) ? html`
    <davinci-legend-grid-block id="${this.placement}" type="vbox">
      ${this._genItems(0)}
    </davinci-legend-grid-block>
    ` : html``;
  }

  _generateW() {
    return this.placement.match(/[NS]?W/) ? html`
    <davinci-legend-grid-block id="${this.placement}" type="vbox">
      ${this._genItems(0)}
    </davinci-legend-grid-block>
    ` : html``;
  }

  _genItems(part) {
    const {
      start,
      partSize
    } = this._getPartRange(part);

    const partVals = this.labels.slice(start, start + partSize);
    return html`${partVals.map((item, index) => this._getItem(item, index + start))}`;
  }

  _getPartRange(part) {
    var _this$labels$length, _this$labels;

    const parts = this._calcParts();

    const items = Math.min((_this$labels$length = (_this$labels = this.labels) === null || _this$labels === void 0 ? void 0 : _this$labels.length) !== null && _this$labels$length !== void 0 ? _this$labels$length : 0, this.maxItems);
    const rem = items % parts;
    const w = rem > part ? 1 : 0;
    const partSize = (items - rem) / parts + w;
    const start = part * partSize + (1 - w) * rem;
    return {
      start,
      partSize
    };
  }

  _getItem(item, index) {
    let right = false;
    const len = this.symbolPositions.length;

    if (len > 0) {
      right = this.symbolPositions[index % len] === 'right';
    }

    let eyeIcon = '';

    if (this.interactiveLegend && this._legendState[index]) {
      eyeIcon = this._legendState[index].active ? SvgTools.REPLACE_FILL_COLOR(icon_visibility, resolveCssColor('var(--davinci-color-text-on-background)')) : SvgTools.REPLACE_FILL_COLOR(icon_visibility_off, resolveCssColor('var(--davinci-color-outline)'));
    }

    if (!this._legendState[index]) {
      // initial state
      const ls = {
        index,
        active: true
      };

      this._legendState.push(ls);
    }

    return html`<davinci-legend-item label="${item}" symbol-size-left="${right ? this.toggleSize : this.symbolSize}" symbol-size-right="${right ? this.symbolSize : this.toggleSize}"
      symbol-right="${right ? this._toSymbol(index) : eyeIcon}"  symbol-left="${right ? eyeIcon : this._toSymbol(index)}"
      ?small-font=${this.smallFont} ?disabled=${!this._legendState[index].active} ?interactive=${this.interactiveLegend} @click="${() => {
      if (this.interactiveLegend) {
        this._legendState[index].active = !this._legendState[index].active; // toggle active state

        this.scheduleRender(true);
        this.legendStateChanged.emit(this._legendState);
      }
    }}"/>`;
  }

  _toSymbol(index) {
    let color = this._itemColors[index % this._itemColors.length].replace('#0x', '#');

    if (this._legendState[index] && !this._legendState[index].active) {
      color = resolveCssColor('var(--davinci-color-outline)');
    }

    return this._currentGenerator(color, index);
  }

  _calcParts() {
    return this.placement === 'N&S' ? 2 : 1;
  }
  /**
   * Computes the colors from the css styles for the legend items.
   */


  _computeItemColors() {
    this._itemColors = this.colors.map(color => toCssColorValue(color, this.palette));
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "labels", [_dec3, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "placement", [_dec5, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'N';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "compact", [_dec7, _dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "interactiveLegend", [_dec9, _dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "legendStateChanged", [_dec11, _dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "symbols", [_dec13, _dec14], Object.getOwnPropertyDescriptor(_class2.prototype, "symbols"), _class2.prototype), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "symbolPositions", [_dec15, _dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "symbolSize", [_dec17, _dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return CssTools.REM2PIXEL(1);
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "toggleSize", [_dec19, _dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return CssTools.REM2PIXEL(1);
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "smallFont", [_dec21, _dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "maxItems", [_dec23, _dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 100;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "colors", [_dec25, _dec26], Object.getOwnPropertyDescriptor(_class2.prototype, "colors"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "paletteWatcher", [_dec27, _dec28], Object.getOwnPropertyDescriptor(_class2.prototype, "paletteWatcher"), _class2.prototype)), _class2)) || _class) || _class);
